import { LandingContent } from "./types";

export const serviceFeeAcademyLanding: LandingContent = {
  ctaText: "Activate the academy",
  quickFacts: ["45-minute completion", "Self-paced", "Member-included"],
  whyHeading: "Why teams use Service Fee Academy",
  why: "The service fee conversation is where deals are won or lost — and most technicians have never been trained to handle it. Service Fee Academy is a cinematic, interactive lesson built around five core principles: anchoring, framing, presence, objection reframing, and confident close. Techs complete in 45 minutes; managers measure ticket-size lift within two weeks.",
  advantages: [
    {
      title: "5 interactive principles",
      description:
        "Anchoring, framing, presence, objection reframing, and confident close — each taught with a cinematic chamber and a short knowledge check.",
      includedNote: "Complete in 45 minutes",
    },
    {
      title: "Narrated throughout",
      description:
        "Every segment is narrated by Prof. Gatewood. Techs who hate reading love this format — completion rates top 93%.",
      includedNote: "Cinematic, genuinely engaging format",
    },
    {
      title: "Manager dashboard",
      description:
        "Track completion, quiz scores, and downstream ticket-size lift per technician.",
      includedNote: "Scripts & objection reframes included",
    },
  ],
  featureChecklist: [
    "Complete in 45 minutes",
    "Cinematic, genuinely engaging format",
    "Scripts & objection reframes included",
    "Measurable ticket lift within 2 weeks",
  ],
  highlights: [],
  steps: [
    {
      title: "Assign the academy",
      description:
        "Add your team in two clicks; everyone gets a personal completion link they can take from any device.",
    },
    {
      title: "Techs complete in 45 minutes",
      description:
        "Cinematic chambers + short knowledge checks. Most teams finish in a single Tuesday afternoon.",
    },
    {
      title: "Managers measure lift",
      description:
        "Watch ticket sizes climb in the dashboard within two weeks of completion.",
    },
  ],
  testimonials: [],
  faqs: [
    {
      question: "How long does it take?",
      answer:
        "About 45 minutes per technician. Most teams complete it in a single afternoon.",
    },
    {
      question: "Do I need to attend with my team?",
      answer:
        "No. The academy is fully self-paced. Manager dashboards show completion and quiz scores in real time.",
    },
    {
      question: "Will it work for my CSRs?",
      answer:
        "Yes — the principles apply equally to inbound price-call handling and in-home service-fee presentation.",
    },
  ],
  closing: {
    heading: "Master the service fee in one afternoon",
    body: "Activate Service Fee Academy for your whole team and watch ticket sizes climb within two weeks.",
  },
};
